<article class="bd-homepage" aria-live="polite">
  <div class="bd-homepage-page">
    <aside class="bd-homepage-sidebar" aria-label="Filter business development events">
      <div class="filter-container">
        <div class="filter-container__header">
          <h3 class="filter-title">Filters</h3>
          <div class="filter-container__actions">
            <button
              mat-button
              class="filterButtons"
              (click)="clearFilters()"
              [disabled]="loadingFilterOptions || filterError"
            >
              Clear
            </button>
          </div>
        </div>

        <div class="filter-fields">
          <div *ngIf="filterError" class="filter-error">
            There was a problem loading the filter options. Try again later.
          </div>

          <ng-select-override
            [items]="filterOptions.staff"
            placeholder="Staff"
            [multipleSelect]="true"
            [isLoading]="loadingFilterOptions"
            [error]="filterError"
            (onChange)="onFilterChange($event, 'staff')"
            [setModel]="selectedStaffOptions"
          >
          </ng-select-override>

          <ng-select-override
            [items]="filterOptions.types"
            placeholder="Event Type"
            [multipleSelect]="true"
            [isLoading]="loadingFilterOptions"
            [error]="filterError"
            (onChange)="onFilterChange($event, 'type')"
            [setModel]="selectedTypeOptions"
          >
          </ng-select-override>
        </div>
      </div>
    </aside>

    <div class="bd-homepage-main">
      <div class="admin-layout-header-container bd-homepage-header">
        <div class="bd-homepage-header__text">
          <h2 class="admin-layout-header">Business Development</h2>
          <p class="admin-layout-description bd-homepage-subtitle">
            <mat-icon class="bd-homepage-subtitle__icon" aria-hidden="true">cases</mat-icon>
            <span class="bd-homepage-subtitle__text">Business Development Events</span>
          </p>
        </div>

        <nav
          *ngIf="availableTabs.length"
          class="bd-homepage-header__tabs"
          role="tablist"
          aria-label="Business development event categories"
        >
          <button
            type="button"
            class="bd-homepage-header__tab"
            *ngFor="let tab of availableTabs"
            [class.bd-homepage-header__tab--active]="activeTab === tab"
            (click)="selectTab(tab)"
            role="tab"
            [attr.aria-selected]="activeTab === tab"
          >
            {{ tab }}
          </button>
        </nav>
      </div>

      <mat-divider class="admin-divider-spacing"></mat-divider>

      <section class="bd-homepage-content" aria-label="Business development events">
        <bd-events (tabChanged)="onTabChanged($event)"></bd-events>
      </section>
    </div>
  </div>
</article>
